import { Polygon } from 'geojson';
import { ISegmentationFeature, SegmentationGeometry } from '../../modules/annotation/annotations.interface';
import { AnnotationToolType } from '../../modules/annotation/submodules/annotationTypes/models/annotationToolType';

export const fixPseudoRectangle = (feature: ISegmentationFeature): ISegmentationFeature => {
  switch (feature.featureType) {
    case AnnotationToolType.RECTANGLE:
      return { ...feature, geometry: fixPseudoRectangleGeometry(feature.geometry) };
    case AnnotationToolType.POLYGON:
    case AnnotationToolType.ROTATEDRECTANGLE:
      return { ...feature, geometry: fixPseudoPolygonGeometry(feature.geometry) };
    case AnnotationToolType.SELECT:
    case AnnotationToolType.POINT:
    case AnnotationToolType.VECTOR:
    case AnnotationToolType.POLYLINE:
    case AnnotationToolType.BRUSH:
    default: {
      return feature;
    }
  }
};

export const fixPseudoRectangleGeometry = (geometry: SegmentationGeometry): SegmentationGeometry => {
  const polygon: Polygon = geometry as Polygon;
  const xs = polygon.coordinates[0].map((c) => c[0]);
  const lats = polygon.coordinates[0].map((c) => c[1]);
  const xMin = Math.min(...xs);
  const xMax = Math.max(...xs);
  const yMin = Math.min(...lats);
  const yMax = Math.max(...lats);

  polygon.coordinates = [
    [
      [xMin, yMin],
      [xMax, yMin],
      [xMax, yMax],
      [xMin, yMax],
      [xMin, yMin],
    ],
  ];

  return polygon;
};

const fixPseudoPolygonGeometry = (geometry: SegmentationGeometry): SegmentationGeometry => {
  const polygon: Polygon = geometry as Polygon;

  if (polygon.coordinates.length && polygon.coordinates[0].length) {
    const first = polygon.coordinates[0][0];
    polygon.coordinates[0][polygon.coordinates.length - 1] = first;
  }

  return polygon;
};
